import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "@hooks/useAllowFeature";
import { ReconciliationPage } from "./ReconciliationPage";
import { ReconciliationPaywalled } from "./ReconciliationPaywalled";

export const ReconciliationPageWrapper = () => {
    const { hasAccess, isFetched } = useAllowFeature(
        PREMIUM_FEATURES.RECONCILIATION,
    );

    if (!isFetched) {
        return null;
    }

    if (!hasAccess) {
        return <ReconciliationPaywalled />;
    }

    return <ReconciliationPage />;
};
